export const ru = {
    'choose-campaign-type': 'Выберите тип кампании'
};
